import EmotionEmoji from "../components/emoji/emoji";

export const renderUserThumbnail = (currentMemberData) => {
  // Log the user object to verify its structure
  // Check for a profile picture preference and existence of URL
  if (currentMemberData.thumbnailPreference === "picture" && currentMemberData.profileImageUrl) {
    return (
      <div className="userThumbnail profileImage">
        <img src={currentMemberData.profileImageUrl} />
      </div>
    );
  }
  // Fallback to rendering an emoji if no profile image URL is available
  // or if the preference is not for a picture.
  return <EmotionEmoji currentEmotionId={currentMemberData.emotionconId} />;
};
